import { useState } from 'react';
import styles from './notaFiscalAccordion.module.scss';
import { BrButton } from '@govbr-ds/react-components';
import { NcmTable } from '../baseDeCalculoFormItemNCM/components/baseDeCalculoLista/ncmTable';

interface IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao {
  notaFiscal?: string;
  dataEmissaoNF?: string;
  quantidadeTotal: string;
  valorTotal: string;
  codigosNCM: ICodigoNcm[];
}

interface ICodigoNcm {
  codigoNCM: string;
  quantidade: string;
  valor: string;
}

interface INotaFiscalAccordionProps {
  componenteBaseCalculo: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao;
  excluirBaseDeCalculo: (componente: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao) => void;
}

function NotaFiscalAccordion({ componenteBaseCalculo, excluirBaseDeCalculo }: Readonly<INotaFiscalAccordionProps>) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const iconClass = !isAccordionOpen ? 'fas fa-angle-down' : 'fas fa-angle-up';

  return (
    <>
      <div
        className={`item`}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <button className={`header`} type='button'>
          <div className={`title ${styles.title}`}>
            <i className={`fas fa-file fa-sm`} />
            <span className={styles.titleDivisor}> Nota Fiscal Nº {componenteBaseCalculo.notaFiscal}</span>
            <span className={styles.titleDivisor}>Data Nota Fiscal: {componenteBaseCalculo.dataEmissaoNF}</span>
          </div>
          <span className={`icon`}>
            <i className={iconClass} />
          </span>
        </button>
      </div>
      {isAccordionOpen && (
        <div className={styles.accordionContent}>
          <NcmTable
            listaCodigosNCM={componenteBaseCalculo.codigosNCM}
            isLoading={false}
            setListaCodigosNCM={() => {}}
            headers={[
              { field: 'codigoNCM', label: 'Código NCM' },
              { field: 'quantidade', label: 'Quantidade' },
              { field: 'precoUnitario', label: 'Preço Unitário' },
              { field: 'valor', label: 'Valor de Aquisição' },
            ]}
          />
          <div className={styles.buttonContainer}>
            <BrButton
              className={styles.button}
              secondary
              onClick={() => {
                setIsAccordionOpen(false);
                excluirBaseDeCalculo(componenteBaseCalculo);
              }}
            >
              <i className={`fas fa-trash-alt fa-sm  ${styles.columnIcon}`} /> Excluir
            </BrButton>
          </div>
        </div>
      )}
    </>
  );
}

export default NotaFiscalAccordion;
